require('../../modules/es.string.pad-start');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'padStart');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/string/pad-start.js
// module id = 1231
// module chunks = 1